<template>
    <PocketButton
        :is-dark-mode="isDarkMode"
        class="skip-to-content"
        @click="skipToContent"
    >
        Skip to Content
    </PocketButton>
</template>

<script setup lang="ts">
import { userModule } from '@/store/user/module'
import UIKit from '@pocketprep/ui-kit'
import { computed } from 'vue'

const {
    Button: PocketButton,
} = UIKit

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const skipToContent = () => {
    const headEl: HTMLElement | null = document.querySelector('.head')
    const questionContextEl: HTMLElement | null = document.querySelector('.uikit-question-context')

    if (headEl) {
        const bodyEl = headEl.nextElementSibling as HTMLElement
        bodyEl?.focus()
    } else if (questionContextEl) {
        questionContextEl.focus()
    }
}
</script>

<style lang="scss" scoped>
.skip-to-content {
    position: absolute;
    left: -1000px;
    top: 50px;
    z-index: 10000;

    &:focus {
        left: 15px;
    }

    @include breakpoint(black-bear) {
        display: none;
    }
}
</style>
